import React from 'react';
import Button from '../shared/Button.js';
import InlineNotice from '../shared/InlineNotice.js';
import type {useLayerReportAnchors} from './useLayerReportAnchors.js';

export default function LayerReportAnchorNotice({anchors}: {anchors: ReturnType<typeof useLayerReportAnchors>}) {
  if (!anchors.pending.length) return null;
  return (
    <div data-layer-anchor-pending="1">
      <InlineNotice
        notice={{
          kind: 'warning',
          message:
            'Report saved. The housing count is still unchanged.\n' +
            anchors.pending.map((item) => `${item.label}: ${item.message}`).join('\n'),
        }}
        action={
          <Button disabled={anchors.busy} onClick={() => void anchors.retry()}>
            {anchors.busy ? 'Retrying…' : 'Retry Count Update'}
          </Button>
        }
      />
    </div>
  );
}
